<template>
  <a-modal
    :visible="visible"
    :width="1000"
    title="新增企业"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <a-spin :spinning="spinning">
      <a-form :form="form" v-bind="formItemLayout" @submit="handlePost">
        <a-row :gutter="24" class="overflow-hidden">
          <a-col :span="8">
            <a-form-item v-bind="formUploadLayout" label="营业执照">
              <div class="overflow-hidden">
                <a-input
                  v-show="false"
                  v-decorator="[
                    'license',
                    { rules: [{ required: true, message: '请上传营业执照' }] },
                  ]"
                ></a-input>
                <Upload @upload="licenseUpload"></Upload>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-bind="formUploadLayout" label="开户许可证">
              <div class="overflow-hidden">
                <a-input
                  v-show="false"
                  v-decorator="[
                    'certificate_src',
                    {
                      rules: [{ required: true, message: '请上传开户许可证' }],
                    },
                  ]"
                ></a-input>
                <Upload @upload="certUpload"></Upload>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-bind="formUploadLayout" label="资质证书">
              <div class="overflow-hidden">
                <a-input v-show="false" v-decorator="['qualification_src']"></a-input>
                <Upload @upload="qUpload"></Upload>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="企业名称">
              <a-textarea
                v-decorator="['owner', { rules: [{ required: true, message: '请输入企业名称' }] }]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="社会信用代码">
              <a-textarea
                v-decorator="[
                  'taxNumber',
                  {
                    rules: [{ required: true, message: '请输入社会信用代码' }],
                  },
                ]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="法人代表">
              <a-textarea
                v-decorator="[
                  'legal_person',
                  { rules: [{ required: true, message: '请输入法人代表' }] },
                ]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="地址">
              <a-textarea
                v-decorator="['address', { rules: [{ required: true, message: '请输入地址' }] }]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开户行">
              <a-textarea
                v-decorator="['bankName', { rules: [{ required: true, message: '请输入开户行' }] }]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开户企业名称">
              <a-textarea
                v-decorator="[
                  'name',
                  {
                    rules: [{ required: true, message: '请输入开户企业名称' }],
                  },
                ]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开户行账号">
              <a-textarea
                v-decorator="[
                  'bankAccount',
                  { rules: [{ required: true, message: '请输入开户行账号' }] },
                ]"
                autoSize
              ></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="电话">
              <a-textarea v-decorator="['tel']" autoSize></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系人">
              <a-textarea v-decorator="['contact_name']" autoSize></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系人电话">
              <a-textarea v-decorator="['contact_tel']" autoSize></a-textarea>
            </a-form-item>
          </a-col>
          <a-form-item :wrapperCol="{ span: 8, offset: 6 }">
            <a-button class="mr-6" type="primary" size="default" html-type="submit"> 提交</a-button>
            <a-button size="default" @click="$emit('cancel')">取消</a-button></a-form-item
          >
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
  import { licenseocr, cert_ocr, companySave } from '@/api/company';
  import { pick } from 'lodash';
  import Upload from '@/components/Upload/index';
  import permission from '@/utils/permission';
  export default {
    components: {
      Upload,
    },
    props: {
      visible: Boolean,
    },
    data() {
      return {
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        formUploadLayout: {
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
        },
        form: this.$form.createForm(this, { name: 'company' }),
        spinning: false,
        certOwner: '',
        check_owner: true,
      };
    },
    watch: {
      visible(a) {
        if (a) {
          setTimeout(() => this.form.resetFields(), 1);
        }
      },
    },
    methods: {
      async licenseUpload(res) {
        console.log(res);
        try {
          setTimeout(() => this.form.setFieldsValue({ license: res.pathname }), 1);
          let ocrres = await licenseocr(res.id);
          let ocrrespick = pick(ocrres, ['address', 'taxNumber', 'owner', 'legal_person']);
          setTimeout(() => this.form.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async certUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ certificate_src: res.pathname }), 1);
          let ocrres = await cert_ocr(res.id);
          let ocrrespick = pick(ocrres, ['bankAccount', 'bankName']);
          ocrrespick.name = ocrres.owner;
          setTimeout(() => this.form.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      qUpload(res) {
        this.setTimeout(() => this.form.setFieldsValue({ qualification_src: res.pathname }), 1);
      },
      async handlePost(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            if (values.name != values.owner) {
              this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
              return;
            }
            try {
              this.spinning = true;
              let data = values;
              data.status_id = 2;
              if (permission(['contract', 'apply/:id?'], 'bind_company')) {
                data.is_review = true;
              }
              let res = await companySave(data);
              data.id = res;
              this.$emit('ok', data);
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.$emit('cancel');
              this.spinning = false;
            }
          } else {
            console.log(values);
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
  :deep(.ant-row) {
    position: static;
  }
</style>
